import { BadgeVariant } from '@Components';
import {
  GS1_PLAN_NAME_INVENTARIO_INTELIGENTE_RETAILER,
  GS1_PLAN_NAME_INVENTARIO_INTELIGENTE_SUPPLIER,
  GS1_PLAN_NAME_SMB,
} from './constants/gs1PlanNames';

interface PlanMeta {
  description: string;
  variant: BadgeVariant;
}

// Plan/PlanOption from the backend carries no description/color — this is
// a deliberate, migration-free static lookup, not a gap. Keyed by plan
// `name` (slug, not display_name). Extend as new plans are introduced.
const PLAN_META: Record<string, PlanMeta> = {
  basico: { description: 'Funcionalidad esencial de inventario.', variant: 'gray' },
  intermedio: { description: 'Analítica avanzada y clustering.', variant: 'brand' },
  avanzado: { description: 'Suite completa con predicción y alertas.', variant: 'brand' },
  [GS1_PLAN_NAME_SMB]: { description: 'Funcionalidad esencial para proveedores SMB.', variant: 'orange' },
  [GS1_PLAN_NAME_INVENTARIO_INTELIGENTE_SUPPLIER]: {
    description: 'Analítica de inventario completa.',
    variant: 'brand',
  },
  [GS1_PLAN_NAME_INVENTARIO_INTELIGENTE_RETAILER]: { description: '', variant: 'brand' },
};

const DEFAULT_PLAN_META: PlanMeta = { description: '', variant: 'brand' };

const getPlanMeta = (name: string | null | undefined): PlanMeta => (name && PLAN_META[name]) || DEFAULT_PLAN_META;

export { getPlanMeta };
export type { PlanMeta };
